import Api from '../Api';

import { url } from './config';
import { SupplierInterface } from './model';

const api = new Api<SupplierInterface>(url);

export default api;
